var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editFaq }
            },
            [_vm._v("Edit FAQ")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.faq
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.faq.faqId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Section Header")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.faq.faqHeader))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Question")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.faq.question))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Answer")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.faq.response))])
              ]),
              _vm._v(" "),
              _c("tr"),
              _c("tr", [
                _c("th", [_vm._v("Image")]),
                _vm._v(" "),
                _c("td", [
                  _vm.faq.faqImageUrl
                    ? _c("img", {
                        staticClass: "table-thumbnail",
                        attrs: {
                          src: _vm.faq.faqImageUrl,
                          title: _vm.faq.faqImageUrl
                        }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Vidoe Code")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.faq.faqVideoUrl))])
              ]),
              _vm._v(" "),
              _c("tr"),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.faq.active
                  ? _c("td", [_vm._v("Active")])
                  : _c("td", [_vm._v("Inactive")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("FAQ Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c72fd82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c72fd82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Faqs/FaqDetails.vue
// module id = rTxB
// module chunks = 0